/**
 * Ссылки на юридические документы приходят из WordPress: тема печатает их
 * в <head> как window.__DALLI_DOCS__ (см. themes/dalli/core/documents.php).
 *
 * Смысл в том, чтобы при следующем переезде страниц адрес правился ровно
 * в одном месте — в теме, а не тут и в PHP одновременно.
 * Значения ниже — только запасной вариант на случай, если скрипт темы
 * почему-то не отработал (например, компонент рендерится вне страницы WP).
 */

export type DocumentKey = 'policy' | 'personalData' | 'newsletter' | 'terms';

const FALLBACK_DOCUMENT_URLS: Record<DocumentKey, string> = {
  policy: '/clients/dokumenty/politika-konfidenczialnosti/',
  personalData: '/clients/dokumenty/soglasiye-na-obrabotku-personalnykh-dannykh/',
  newsletter: '/clients/dokumenty/soglasiye-na-polucheniye-novostnoy-i-reklamnoy-rassylki/',
  terms: '/clients/dokumenty/polzovatelskoye-soglasheniye/',
};

declare global {
  interface Window {
    __DALLI_DOCS__?: Partial<Record<DocumentKey, string>>;
  }
}

export const documentUrl = (key: DocumentKey): string => {
  if (typeof window !== 'undefined') {
    const fromWordpress = window.__DALLI_DOCS__?.[key];
    if (fromWordpress) {
      return fromWordpress;
    }
  }

  return FALLBACK_DOCUMENT_URLS[key];
};
